import * as React from "react";
import PropTypes from "prop-types";
const SvgAchievementsMedalPrSmall = React.forwardRef(
  ({ color, size, title, titleId, ...props }, ref) => (
    <svg
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      ref={ref}
      width={size}
      height={size}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <g fill="">
        <path d="M21.9 4.51L19.67.33H4.39L2.14 4.57l3.49 6.58a8 8 0 1012.74.01zm-4.277-2.835L16.49 3.8H7.51L6.377 1.675zM3.67 4.57l1.36-2.56 3.59 6.74A7.826 7.826 0 006.6 10.1zm5.83 12.1h-.83V20H7.33v-7.67H9.5c.435-.003.86.126 1.22.37a2.174 2.174 0 01-1.22 3.97zm.39-8.39L8.22 5.15h7.56l-1.67 3.13a8.09 8.09 0 00-4.22 0zM15.57 20l-1.36-3.33h-.54V20h-1.34v-7.67h2.17a2.165 2.165 0 012.16 2.03.614.614 0 01.01.14 2.148 2.148 0 01-1.06 1.85.21.21 0 01-.06.04L17.02 20zm1.83-9.9a7.874 7.874 0 00-2.01-1.35l3.62-6.8 1.37 2.56z" />
        <path d="M14.5 13.68h-.83v1.65h.83a.861.861 0 00.82-.83 1.035 1.035 0 00-.07-.35.836.836 0 00-.75-.47zm-5 0h-.83v1.65h.83a.825.825 0 100-1.65z" />
      </g>
    </svg>
  )
);
SvgAchievementsMedalPrSmall.defaultProps = {
  color: "currentColor",
  size: 24,
  title: undefined,
  titleId: undefined,
};
SvgAchievementsMedalPrSmall.propTypes = {
  color: PropTypes.string,
  size: PropTypes.number,
  title: PropTypes.string,
  titleId: PropTypes.string,
};
export default SvgAchievementsMedalPrSmall;
